var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconcompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.26855 5.48506L10.1865 1.79102L14.5522 5.48506V12.7612V18.6941H6.26855V13.4329V5.48506Z",
    fill: "#D0D3DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 12H15V4.99996C15 4.73486 14.8945 4.48046 14.707 4.29296L10.707 0.292951C10.3164 -0.0976503 9.68362 -0.0976503 9.29292 0.292951L5.29291 4.29296C5.10551 4.48046 5.00001 4.73486 5.00001 4.99996V12H1C0.447801 12 0 12.4478 0 13V19C0 19.5522 0.447801 20 1 20H6.00001H14H19C19.5522 20 20 19.5522 20 19V13C20 12.4478 19.5522 12 19 12ZM5.00001 18H2V14H5.00001V18ZM13 13V18H7.00002V13V5.41406L10 2.41406L13 5.41406V13ZM18 18H15V14H18V18Z",
    fill: "#D0D3DB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8C8 8.5522 8.4478 9 9 9H11C11.5522 9 12 8.5522 12 8C12 7.4478 11.5522 7 11 7H9C8.4478 7 8 7.4478 8 8ZM11 13H9C8.4478 13 8 13.4478 8 14C8 14.5522 8.4478 15 9 15H11C11.5522 15 12 14.5522 12 14C12 13.4478 11.5522 13 11 13Z",
    fill: "#8A92A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconcompany);
export default __webpack_public_path__ + "static/media/Icon.company.72c416a7f9f14912703f5f0ca5033f16.svg";
export { ForwardRef as ReactComponent };